module.exports = __webpack_public_path__ + "img/banner_news.7f035b5e.jpg";